import { FunctionComponent } from 'react'
import { useArchiveRefreshRule, useRefreshRules } from '~/api/adm/refresh-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { ArchivedRulesPage } from './ArchivedRulesPage'

/** The archived refresh rules. The page itself is shared with the other three kinds. */
export const ArchivedRefreshRulesPage: FunctionComponent = () => {
  const { canArchive } = useScopePermissions()
  const { data: refreshRules, isLoading } = useRefreshRules(false, true)
  const { mutateAsync: archiveRefreshRule, isPending } = useArchiveRefreshRule({ successToast: 'Refresh rule unarchived', errorToast: 'Could not unarchive this refresh rule' })

  return (
    <ArchivedRulesPage
      rules={refreshRules}
      isLoading={isLoading}
      noun={'refresh rule'}
      backLabel={'Back to refresh rules'}
      backPath={'/monetization/one/refresh/rules'}
      onUnarchive={(rule) => archiveRefreshRule({ id: rule.id, archived: false })}
      isUnarchiving={isPending}
      canUnarchive={canArchive}
      backTrackingLabel={'adm-refresh-rules-archived-back-navigate'}
      unarchiveTrackingLabel={'adm-refresh-rules-unarchive'}
    />
  )
}
